import React, { Component } from 'react'
import styled from 'styled-components'
import { Modal, Select, SelectSearch, TextInput, Dropzone, Checkbox, Button, Colors } from 'advenio-components'
import { Form } from 'formsy-react' // eslint-disable-line
import { findIndex, propEq, clone } from 'ramda'

import ChargesTable from '../../Components/ProfileViews/Balance/ChargesTable'
import { formatDecimalNumber, parseToInt } from '../../utils/Utils'

// unit_price_price = precio unitario sin IVA ( se usa para sacar el unit_price de la cuenta)
// tax_amout = se utiliza para sacar el IVA total
// total_price = se utitliza para sacar el costo total y el monto de cada elemento

const ConceptInputs = styled.div`
  width: 280px;
  margin-left: ${props => props.start ? '10px' : ''};
`
const InputRow = styled.div`
  display: flex;
  justify-content: ${props => props.start ? 'flex-start' : 'space-around'};
  margin-left: ${props => props.start ? '10px' : ''};
  align-items: center;
`
const InputRow2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
`
const InputContainer = styled.div`
  margin: 0 8px;
  display: ${({ open }) => (open ? 'flex' : 'none')}
  flex-basis: 30%;
`
const DropzoneContainer = styled.div`
  width: 100%;
  height: 200px;
  margin: 16px 0;
`
const InfoBox = styled.div`
  background-color: rgba(254,205,16,.20);
  border: 1px solid #D7AD0B;
  border-radius: 4px;
  flex:1;
  padding: 4px;
  color: ${Colors.blue500};
  margin-left: 10px;
  margin-right: 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const InfoIcon = styled.img`
  width: 20px;
  margin-right: 8px;
`
const QuantityInput = styled.div`
  width: ${({ width }) => width || '65px'};
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 32px 16px 32px 16px;
`

const CalcIvaAndTotal = (charges) => {
  const unit_price = charges
    .reduce((acum, currentCharge) => acum + parseToInt(currentCharge.unit_price), 0)
  const iva = charges
    .reduce((acum, currentCharge) => acum + parseToInt(currentCharge.iva_amount), 0)
  const total_amount = charges
    .reduce((acum, currentCharge) => acum + parseToInt(currentCharge.total), 0)

  return {
    unit_price: formatDecimalNumber(unit_price),
    iva: formatDecimalNumber(iva),
    total_amount: formatDecimalNumber(total_amount),
  }
}

const initialCards = [{ header: '', options: [{ id: 0, value: '', label: '' }] }]

class AdjustModal extends Component {
  state = {
    consumables: [],
    charges: [],
    price: 0,
    iva: 0, // cantidad de dinero derivado del iva
    unit_price: 0,
    total_amount: 0,
    disableAdd: false,
    type: 'charge',
    has_iva: false,
    file: null,
    showCardSelect: false,
    cardsOptions: initialCards,
  }

  componentWillReceiveProps(nextProps) {
    const { student } = nextProps
    if (!nextProps.open) {
      this.setState({ showCardSelect: false })
    }

    if (student && student.credit_cards.length > 0) {
      const options = student.credit_cards.map(c => ({
        id: c.id,
        label: `${c.card_brand} ${c.last_four}`,
        value: c.id,
      }))
      const methods = nextProps.paymentTypes.map(type => ({
        id: type.id,
        label: type.type.name,
        value: type.id,
      }))
      this.setState({ cardsOptions: [{ header: '', options }], paymentTypes: methods })
    } else {
      const paymentMethods = nextProps.paymentTypes.map(type => ({
        id: type.id,
        label: type.type.name,
        value: type.id,
      }))
      const paymentMethodsWithoutCard = paymentMethods.filter(
        method => method.label.indexOf('Tarjeta') < 0 && method.label.indexOf('Card') < 0,
      )
      this.setState({ paymentTypes: paymentMethodsWithoutCard })
    }
    // `id` alone is not a unique key across this list — CenterConsumable and
    // TuitionFeeType are separate tables and their ids can collide (e.g. both
    // can have id=4). SelectSearch's internal Options component uses `id` as
    // the React `key`, so a raw colliding id causes React to misreconcile
    // list items on filter/re-render (duplicated/ghost rows in the dropdown).
    // We use the same synthetic `${type}_${id}` for both `id` and `value` so
    // every option is truly unique. The original numeric `id` is kept as
    // `originalId` in case it's needed later.
    const consumables = nextProps.consumables.map(({ id, type, consumable }) => ({
      id: `${type}_${id}`,
      originalId: id,
      type,
      value: `${type}_${id}`,
      label: consumable,
    }))

    this.setState({ consumables })
  }

  addCharge = (data) => {
    const { consumables, isMexican, tax } = this.props
    const { charges, type: originalType } = this.state
    const type = originalType.toLowerCase()
    // CARGOS EN STATE
    if (type === 'payment') {
      const { concept, has_iva, price = 0.00, product_key, unit_key } = data

      const formattedSubtotal = formatDecimalNumber(price)
      const parsedSubtotal = parseToInt(formattedSubtotal)
      const taxPct = tax / 100
      const taxTotal = formatDecimalNumber(parsedSubtotal * taxPct)
      const formattedTotal = formatDecimalNumber(parsedSubtotal * (taxPct + 1))
      const total = has_iva ? formattedTotal : formattedSubtotal

      const newCharge = {
        id: concept,
        concept,
        description: concept,
        total_price: total,
        total,
        unit_price: formattedSubtotal,
        iva_amount: has_iva ? taxTotal : 0,
        has_iva,
        type,
        product_key: isMexican ? product_key : null,
        unit_key: isMexican ? unit_key : null,
        amount: total,
        created_at: Date.now(),
      }
      charges.push(newCharge)
      const { iva, unit_price, total_amount } = CalcIvaAndTotal(charges)

      this.setState({ charges, disableAdd: true, iva, unit_price, total_amount })
    } else {
      const { quantity, is_retention, concept_id: conceptValue } = data
      // NOTE: `consumables` here is `this.props.consumables` (destructured above
      // in this function), the raw backend list — NOT `this.state.consumables`
      // (which is only used to build the SelectSearch options in render()).
      // `conceptValue` is the synthetic `${type}_${id}` value from the select —
      // it uniquely identifies the record, unlike the raw `id` which can collide
      // between CenterConsumable and TuitionFeeType.
      const [consum] = consumables.filter(
        consumable => `${consumable.type}_${consumable.id}` === conceptValue,
      )
      const { id: concept_id, total_price, tax_amount, subtotal_price, consumable } = consum
      const newCharge = {
        id: concept_id,
        quantity,
        is_retention: is_retention !== undefined ? !is_retention : false,
        total_price, // consumable.unit_price
        total: quantity * total_price,
        concept: consumable,
        unit_price: quantity * subtotal_price,
        iva_amount: quantity * tax_amount,
        type,
        amount: quantity * total_price,
        description: consumable,
        created_at: Date.now(),
      }
      charges.push(newCharge)
      const { iva, unit_price, total_amount } = CalcIvaAndTotal(charges)

      this.setState({ charges, disableAdd: true, iva, unit_price, total_amount })
    }
  }

  removeCharge = (id) => {
    const charges = clone(this.state.charges)
    const chargeIndex = findIndex(propEq('id', id))(charges)
    charges.splice(chargeIndex, 1)
    this.setState({ charges })
  }

  checkCharges = ({ price, has_iva, concept, concept_id, amount, type_id }) => {
    const isChargeAdded = this.state.charges.filter((chargeObject) => {
      if (this.state.type.toLowerCase() === 'payment') {
        return chargeObject.id === concept
      }

      return chargeObject.id === concept_id
    })

    if (this.state.type.toLowerCase() === 'payment') {
      this.setState({
        type_id,
        amount,
      })
    }

    const priceWithOrNotIVA = price && has_iva ? price * ((this.props.tax / 100) + 1) : price

    this.setState({
      disableAdd: isChargeAdded.length !== 0,
      price: price && formatDecimalNumber(Number(priceWithOrNotIVA)),
      has_iva,
    })
  }

  sendCharges = () => {
    const { charges } = this.state
    const finalCharges = this.state.type === 'payment' ?
      [
        {
          amount: this.state.amount,
          quantity: 1,
          type_id: this.state.type_id,
          type: 'payment',
          file: this.state.file,
        },
      ]
      : charges
        .map(({ is_retention, id, quantity, type: originalType }) => {
          const type = originalType.toLowerCase()
          return {
            id,
            charge_type: 'consumable',
            is_retention,
            quantity: Number(quantity),
            type,
          }
        })
    this.props.adjustTransaction(this.props.receipt.id, finalCharges)
  }

  beforeClose = () => {
    this.setState({
      charges: [],
      iva: 0,
      unit_price: 0,
      total_amount: 0,
      disableAdd: false,
      type: 'charge',
      has_iva: false,
    })
    this.props.onClose()
  }

  handleTypeChange = e => this.setState({ type: e.currentTarget.value })

  handleFileDrop = (file) => {
    const { onFileDrop } = this.props

    this.setState({ file }, () => onFileDrop && onFileDrop(file))
  }

  handleFormChange = (e) => {
    const { paymentTypes, student } = this.props
    const { value } = e.target
    const { showCardSelect } = this.state
    const paymentType = paymentTypes.find(type => type.id === Number(value))
    this.setState({
      showCardSelect:
        (paymentType.type.name.indexOf('Tarjeta') >= 0 || paymentType.type.name.indexOf('Card') >= 0) &&
        student.credit_cards.length > 0,
    })
  }

  renderAddChargeFields = (originalType) => {
    const { currency, student } = this.props
    const { consumables, disableAdd, paymentTypes, showCardSelect, cardsOptions } = this.state
    const type = originalType.toLowerCase()
    let withRetention = false
    const currencySymbol = currency && currency.symbol
    const currencyCode = currency && currency.code
    if (student && student.product && student.product.type === 'ContractProduct') {
      withRetention = true
    }
    if (type === 'payment') {
      return (
        <div>
          <InputRow>
            <InputContainer open>
              <TextInput
                name="amount"
                label="Monto"
                prefix={currency && currency.symbol}
                suffix={currency && currency.code}
                type="number"
              />
            </InputContainer>
            <InputContainer open>
              <Select
                name="type_id"
                label="Tipo de Pago"
                onChangeCallback={this.handleFormChange}
                options={paymentTypes}
              />
            </InputContainer>
            {showCardSelect &&
              <InputContainer open>
                <Select name="card_id" label="Tarjetas" withGroup optionsWithGroup={cardsOptions} value={cardsOptions[0].options[0].value} options={[]} />
              </InputContainer>
            }
          </InputRow>
          <DropzoneContainer>
            <Dropzone
              onDrop={this.handleFileDrop}
              label="Da click o arrastra un documento aquí"
              onDragLabel="Soltar Documento"
              ref={(dropzone) => {
                this.dropzone = dropzone
              }}
            />
          </DropzoneContainer>
        </div>
      )
    }

    return (
      <InputRow>
        <ConceptInputs>
          <SelectSearch name="concept_id" label="Concepto" options={consumables} required />
        </ConceptInputs>
        <QuantityInput>
          <TextInput name="quantity" label="Cantidad" required type="number" />
        </QuantityInput>
        {withRetention &&
        <Checkbox
          name="is_retention"
          label="Cargo Directo"
          value={!student.pays_by_retention}
          large
          invertedColors
          hideEmptyHelpBlock
        />
        }
        <Button primary type="submit" disabled={disableAdd}>+ Agregar</Button>
      </InputRow>
    )
  }

  render() {
    const { currency, open, sending } = this.props
    const { charges, has_iva, iva, price: originalPrice = '0.00', unit_price,
      total_amount, type: originalType, showCardSelect, cardsOptions, paymentMethods } = this.state
    const currencySymbol = currency && currency.symbol
    const currencyCode = currency && currency.code
    const price = formatDecimalNumber(originalPrice)
    const type = originalType.toLowerCase()
    return (
      <Modal
        isOpened={open}
        onClose={this.beforeClose}
        headerTitle="Ajustar Transacción"
        statePath="balance"
        actionType="transaction"
        typePrefix="BALANCE"
      >
        <Form onSubmit={this.addCharge} onChange={this.checkCharges}>
          <InputRow2>
            <Select
              label="Tipo de transacción"
              name="type"
              options={[
                { id: 0, value: 'charge', label: 'Cargo' },
                { id: 1, value: 'payment', label: 'Pago' },
              ]}
              value={type}
              onChangeCallback={this.handleTypeChange}
            />
          </InputRow2>
          {this.renderAddChargeFields(type)}
          {(type === 'payment' && parseToInt(price) > 0) && (<InfoBox>
            <InfoIcon src="/assets/info_icon.svg" />
            {has_iva
              &&
              <span>Incluyendo el IVA se le cargará un monto de <u>
                {currencySymbol}{price} {currencyCode}</u></span>}
            {!has_iva
              &&
              <span>Se le cargará un monto de <u>{currencySymbol}{price} {currencyCode}</u></span>}
          </InfoBox>)}
          {type !== 'payment' &&
            <ChargesTable
              charges={charges}
              iva={iva}
              unit_price={unit_price}
              currency={currency}
              total_amount={total_amount}
              removeCharge={this.removeCharge}
            />
          }
          <ButtonsContainer>
            <Button onClick={this.beforeClose}>Cancelar</Button>
            <Button onClick={this.sendCharges} loading={sending} primary>Confirmar</Button>
          </ButtonsContainer>
        </Form>
      </Modal>
    )
  }
}

AdjustModal.defaultProps = {
  currency: {},
}
export default AdjustModal



// WEBPACK FOOTER //
// ./src/Containers/ReceiptValidations/AdjustModal.jsx